import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.0009 2.96045L15.4405 10.8531L16.5009 8.92514L23.6921 22.0002H0.291016L11.0009 2.96045ZM12.6921 20.0002H15.5009V17.0002H14.3421L12.6921 20.0002ZM17.5009 20.0002H20.3096L18.6596 17.0002H17.5009V20.0002ZM17.5596 15.0002L16.5009 13.0752L15.4421 15.0002H17.5596Z"}}]};

const PyramidFilled = Vue.extend<IconProps>({
  name: 'PyramidFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pyramid-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PyramidFilled;
